import { useActiveUserPartner } from "@/store/selectors";
import { IAssignmentPrompt } from "@/types/AssignmentTypes";

export const ellerAssignmentPromptConfigs: Partial<IAssignmentPrompt>[] = [
  {
    key: "what-did-you-learn-that-you-can-apply-to-in-person-coffee-chats-networking",
    prompt:
      "What did you learn that you can apply to in-person coffee chats/networking?",
    minCharacters: null,
    maxCharacters: null,
    assignmentTypes: {
      anyAdvizers: true,
    },
  },
  {
    key: "why-did-you-choose-the-advizer-role-industry-that-you-did",
    prompt:
      "Why did you choose to watch the advizers/playlists/videos that you did?",
    minCharacters: null,
    maxCharacters: null,
    assignmentTypes: {
      anyAdvizers: true,
    },
  },
  {
    key: "what-did-you-learn-about-the-job-roles-and-or-what-surprised-you",
    prompt:
      "What did you learn about the advizers' job roles and/or what surprised you?",
    minCharacters: null,
    maxCharacters: null,
    assignmentTypes: {
      anyAdvizers: true,
    },
  },
  {
    key: "what-did-you-learn-about-the-companies-the-advizers-work-for",
    prompt: "What did you learn about the companies the advizers work for?",
    minCharacters: null,
    maxCharacters: null,
    assignmentTypes: {
      anyAdvizers: true,
    },
  },
  {
    key: "is-this-a-career-path-or-company-you-would-want-to-pursue-why-or-why-not",
    prompt:
      "Is this a career path or company you would want to pursue? Why or why not?",
    minCharacters: null,
    maxCharacters: null,
    assignmentTypes: {
      anyAdvizers: true,
    },
  },
];

export const basicAssignmentPromptConfigs: Partial<IAssignmentPrompt>[] = [
  {
    key: "why-did-you-watch-the-videos-you-did",
    prompt: "Why did you watch the videos you did?",
    default: true,
  },
  {
    key: "what-did-you-learn-that-surprised-you-or-helped-you-the-most",
    prompt:
      "What did you learn that surprised/inspired/motivated you the most?",
    default: true,
  },
  {
    key: "what-aspects-about-your-career-path-are-still-unclear",
    prompt:
      "What aspects of your career options/path/goals are you still not confident about? Why?",
    default: true,
  },
  {
    key: "which-career-or-careers-from-the-videos-felt-like-a-good-fit-for-you-and-why",
    prompt:
      "Which career(s) from the videos felt like a good fit for you? Which were a bad fit? Why?",
  },

  {
    key: "what-did-you-learn-that-you-can-apply-to-in-person-coffee-chats-networking",
    prompt:
      "What did you learn that you can apply to in-person coffee chats/networking?",
  },
];

export const useAssignmentPromptConfigs = () => {
  const activeUserPartner = useActiveUserPartner();

  if (activeUserPartner?.slug.includes("eller")) {
    return ellerAssignmentPromptConfigs;
  }

  return basicAssignmentPromptConfigs;
};

export const useDefaultAssignmentPromptConfigs = () => {
  const activeUserPartner = useActiveUserPartner();

  if (activeUserPartner?.slug.includes("eller")) {
    return [];
  }

  return basicAssignmentPromptConfigs.filter((prompt) => prompt.default);
};
